import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as i18next from 'i18next';
import * as api from 'core/api';
import * as auth from 'core/auth';
import * as utils from 'core/utils';
import * as flights from 'core/flights';
import FlightAgencyTermsComponent from 'src/components/flight/agency-terms';
import PaymentFormComponent from 'src/components/payment/form';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component({
    components: {
        'v-flight-agency-terms': FlightAgencyTermsComponent,
        'v-payment-form': PaymentFormComponent
    }
})
export default class FlightsBookingPaymentComponent extends Vue {
    $auth: auth.AuthService; // Injected in G2S.init

    @Prop()
    currentUser: api.UserWithBonuses;

    @Prop()
    reservation: flights.ReservationModel;

    @Prop()
    flightBookingDetails: api.FlightBookingDetails;

    @Prop()
    searchId: string;

    @Prop()
    gaParams: utils.GoogleAnalyticsParams;

    @Prop()
    gaAlreadySubmitted: string[];

    @Prop()
    v: any;

    get productsOfTypeInsuranceForPaymentStep() {
        return this.reservation.productsOfTypeInsurance.filter(({ product }) =>
            product.stepNumber === 3
        );
    }

    get productOfTypeServiceOrPackageForPaymentStep() {
        return this.reservation.productsOfTypeServiceOrPackage.filter(({ product }) =>
            product.stepNumber === 3 && product.flightId == this.reservation.selectedFlightIdForProducts || product.stepNumber === 3 && product.flightId == null
        );
    }

    get stepThreeBrands(){
        return this.reservation.brandedProductKits?.filter(b => {
            return b.stepOnForm === 3 && b.kitTarget !== 'AdditionalPopup';
        }) ?? [];
    }

    mounted() {
        const productsRocket = [
            ...this.productsOfTypeInsuranceForPaymentStep.map((product) => product.product),
            ...this.productOfTypeServiceOrPackageForPaymentStep.map((product) => product.product)
        ];

        for (const brand of this.stepThreeBrands) {
            for (const product of brand.products) {
                const productByBrand = this.reservation.products.find(p => product.id && p.product.id === product.id);
                if (productByBrand) {
                    productsRocket.push(productByBrand.product);
                }
            }
        }

        new api.RetailRocket().orderFormStepOpened({
            flightKey: api.RetailRocketCL.flightKey,
            stepNumber: 3,
            products: productsRocket,
            bookingSessionId: this.flightBookingDetails.bookingSessionId,
            email: this.reservation.contacts.email
        });
    }

    onProductDetails(product: flights.ProductModel) {
        this.$emit('product-details', product);
    }

    onFlightTerms() {
        if (this.reservation.selectedFlight) {
            this.$emit('flight-terms', this.reservation.selectedFlight.uniqueId);
        }
    }

    onProductSelectionChange(product: flights.ProductModel, value: boolean) {
        this.$emit('product-selection-change', product, value);
    }

    onCardNumberInputOnce() {
        (<any>this).$ga.sendEvent('flights.booking', 'card.input.started', 'flights.booking.card.input.started', this.gaParams);
        (<any>this).$ga.sendPageview('/flights/booking/payment/card/inputstart', 'Flights / Booking / Payment / Card / Inputstart', this.gaParams);
    }

    onSubmit() {
        if (this.productOfTypeServiceOrPackageForPaymentStep.some(p => p.needToSelect) || this.stepThreeBrands.some(b => b.needToSelect)) {
            this.reservation.needToSelectToGoToNextStep = true;
            (<any>this.$root).$refs.dialogMessage.show({
                text: i18next.t('label_error_need_select_modal'),
                btnOkLabel: 'OK',
                persistent: true,
                btnOkColorClass: 'btn-alternate',
                btnOkHandler() {
                    (<any>this).$refs.dialog.isActive = false;
                }
            });
            return;
        } else {
            this.reservation.needToSelectToGoToNextStep = false;
        }

        //this.v.termsAccepted.$touch();
        const paymentFormError = (<any>this.$refs).paymentForm.validate();

        const g = utils.clone(this.gaParams);
        g.dimension1 = this.reservation.payment!.selectedPaymentTypeId;

        const selectedPayment = this.reservation.payment!.selectedPaymentType;
        const selectedPaymentMethod = selectedPayment.isYandexPay ? this.reservation.payment!.selectedPaymentMethod : '';

        (<any>this).$ga.sendPageview('/flights/booking/submit', 'Flights / Booking / Submit', this.gaParams);

        (<any>this).$ga.sendEvent(
            'flights.booking',
            `payment.${selectedPayment.kind}.${selectedPayment.paymentTypeId}${selectedPaymentMethod ? '.' + selectedPaymentMethod.type : ''}.submit`.toLowerCase(),
            `flights.booking.payment.${selectedPayment.kind}.${selectedPayment.paymentTypeId}${selectedPaymentMethod ? '.' + selectedPaymentMethod.type : ''}.submit`.toLowerCase(),
            this.gaParams
        );

        if (paymentFormError) {
            const title = i18next.t('error');
            let error = null;

            //if (!error
            //    && this.v.termsAccepted.$error) {
            //    error = i18next.t('error_terms');
            //}

            if (!error
                && paymentFormError
                && paymentFormError !== i18next.t('error_fields')) {
                error = paymentFormError;
            }

            if (!error) {
                error = i18next.t('error_fields');
            }

            (<any>this.$root).$refs.dialogMessage.show({
                title: title,
                text: error
            });

            if (this.gaAlreadySubmitted.indexOf('flights.booking.step3.error') < 0) {
                (<any>this).$ga.sendEvent('flights.booking', 'step3.error', 'flights.booking.step3.error', this.gaParams);
                (<any>this).$ga.reachGoal('flights.booking.step3.error');

                this.gaAlreadySubmitted.push('flights.booking.step3.error');
            }
        } else {
            this.$emit('submit');
        }
    }
}
